import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

export default function NotFound() {
    const navigate = useNavigate();
    const [count, setCount] = useState(10);

    // Auto-redirect countdown
    useEffect(() => {
        if (count <= 0) {
            navigate("/");
            return;
        }
        const timer = setTimeout(() => setCount((c) => c - 1), 1000);
        return () => clearTimeout(timer);
    }, [count]);

    return (
        <div className="min-h-[70vh] flex items-center justify-center px-4">
            <div className="text-center max-w-md">
                {/* 404 */}
                <div className="relative inline-block mb-8">
                    <span className="text-[120px] md:text-[160px] font-black text-neutral-100 leading-none select-none">
                        404
                    </span>
                    <div className="absolute inset-0 flex items-center justify-center">
                        <span className="text-5xl">🔍</span>
                    </div>
                </div>

                <h1 className="text-2xl md:text-3xl font-bold text-neutral-900 mb-3">
                    Page Not Found
                </h1>
                <p className="text-neutral-500 mb-8 leading-relaxed">
                    Sorry, the page you're looking for doesn't exist or has been
                    moved. Redirecting to home in{" "}
                    <strong className="text-primary-600">{count}s</strong>...
                </p>

                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                    <Link to="/" className="btn-primary px-8 py-3">
                        Go Home
                    </Link>
                    <Link to="/shop" className="btn-secondary px-8 py-3">
                        Browse Shop
                    </Link>
                    <button
                        onClick={() => navigate(-1)}
                        className="btn-secondary px-8 py-3 cursor-pointer"
                    >
                        Go Back
                    </button>
                </div>
            </div>
        </div>
    );
}
